/**
 * Status da Policy no InsureMO (campo PolicyStatus)
 * Apenas os status exibidos no portal
 */
export enum PolicyStatus {
  /** Apólice emitida */
  Effective = 2,
  /** Apólice cancelada */
  Rejected = 3,
}

/**
 * Descrições dos status da Policy em português
 */
export const PolicyStatusDescriptions: Record<number, string> = {
  [PolicyStatus.Effective]: 'Emitida',
  [PolicyStatus.Rejected]: 'Cancelada',
};
